import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../config.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { finalize } from 'rxjs/operators';
import { ExceptionHandlingService } from '../../shared/exception-handling.service';

@Component({
  selector: 'app-record-violations',
  templateUrl: './record-violations.component.html',
  styleUrls: ['./record-violations.component.scss']
})
export class RecordViolationsComponent implements OnInit {

  error:any={};

  constructor(
    public translate: TranslateService,
    private service: SharedService,
    private appConstants : AppConstants,
    private errorService: ExceptionHandlingService
  ) { }

  isLoading:boolean=false;
  ngOnInit() {

  }

  violation:any={
    componentReceiptFailure:false,
    componentTestFailure:false
  }

  regions:any=[];
  regionsLoading:boolean=false;
  getRegions(){
    this.regionsLoading = true;
    let url = this.appConstants.endPoints.certificatesEndPoint + 'options/accreditations/certificate-regions'
    this.service
      .post(url, {status:true,isPaging:false}, {})
      .pipe(finalize(() => {
        this.regionsLoading = false;
      }))
      .subscribe(data => {
        this.regions = data.searchResults
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }

  markTypes:any=[];
  markTypesLoading:boolean=false;
  getMarkTypes(){
    this.markTypesLoading = true;
    let url = this.appConstants.endPoints.accreditationEndPoint + 'options/certification-mark-types'
    this.service
      .post(url, {
        "isPaging:": true,
        "pageSize": 25,
        "pageNumber": 1,
        //"name": "search val"
      }, {})
      .pipe(finalize(() => {
        this.markTypesLoading = false;
      }))
      .subscribe(data => {
        this.markTypes = data.searchResults
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }
  
  queues:any=[];
  queuesLoading:boolean=false;
  getQueues(){
    this.queuesLoading = true;
    let url = this.appConstants.endPoints.deliveryOrganizationEndPoint + 'options/work-queues'
    this.service
      .post(url, {
        "isPaging:": true,
        "pageSize": 25,
        "pageNumber": 1,
        //"name": "search val"
      }, {})
      .pipe(finalize(() => {
        this.queuesLoading = false;
      }))
      .subscribe(data => {
        this.queues = data.searchResults
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }

  recordViolation(){
    console.log(this.violation)
  }

}
